export default {
	init() {
		initAccordion({
			container: ".accordion-block",
			trigger: ".accordion__trigger",
		});
	},
};

const initAccordion = ({ container, trigger }) => {
	const accordionBlocks = document.querySelectorAll(container);
	if (!accordionBlocks.length) return;

	accordionBlocks.forEach((block) => {
		const buttons = block.querySelectorAll(trigger);

		buttons.forEach((button) => {
			button.addEventListener("click", function () {
				const panelId = this.getAttribute("aria-controls");
				const panel = document.getElementById(panelId);
				if (!panel) return;

				const isExpanded = this.getAttribute("aria-expanded") === "true";

				// Close all panels in this accordion
				buttons.forEach((btn) => {
					const pid = btn.getAttribute("aria-controls");
					const pnl = document.getElementById(pid);
					if (!pnl) return;

					btn.classList.remove("active");
					btn.setAttribute("aria-expanded", "false");
					pnl.style.maxHeight = null;
				});

				// Open clicked panel
				if (!isExpanded) {
					this.classList.add("active");
					this.setAttribute("aria-expanded", "true");
					panel.style.maxHeight = panel.scrollHeight + "px";
				}
			});
		});
	});
};